'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sign = require('babel-runtime/core-js/math/sign');

var _sign2 = _interopRequireDefault(_sign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _consts = require('photography-client-lib/dist/src/utils/consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swipper = function () {
  function Swipper(config, callback) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Swipper);

    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    this.init(config);

    this.initDefaults();

    this.swipeCallback = _lodash2.default.isFunction(callback) ? callback : _lodash2.default.noop;

    this.opts = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          // console.log('Browser has passive events');
          _this.opts = {
            passive: true
          };
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
  }

  //--------------------| INIT |--------------------//

  (0, _createClass3.default)(Swipper, [{
    key: 'init',
    value: function init(config) {
      this.initElements();
      this.initEvents();

      this.setConfiguration(config);
    }
  }, {
    key: 'initElements',
    value: function initElements() {
      this.wrap = $('.pro-fullscreen-swipe-wrap');
      this.slides = $('.pro-fullscreen-slide');
      this.current = $('.swipe-current');
      this.currentItem = $('.current-slide .fullscreen-item').last();
      this.nextItem = $('.next-slide .fullscreen-item');
      this.prevItem = $('.prev-slide .fullscreen-item');

      this.slider = $('#slider');

      this.currentItemContainer = $('.current-slide');
      this.nextItemContainer = $('.next-slide');
      this.prevItemContainer = $('.prev-slide');

      this.currentItemContent = $('.current-slide .fullscreen-content');
      this.nextItemContent = $('.next-slide .fullscreen-content');
      this.prevItemContent = $('.prev-slide .fullscreen-content');

      this.otherItemContainers = $('.swipe-far-away');

      this.isLastSlide = this.nextItem.length === 0;
      this.isFirstSlide = this.prevItem.length === 0;

      this.direction = 0;
    }
  }, {
    key: 'initEvents',
    value: function initEvents() {
      if (this.wrap[0]) {
        this.wrap[0].removeEventListener('touchstart', this.onTouchStart, this.opts);
        this.wrap[0].addEventListener('touchstart', this.onTouchStart, this.opts);
      }
    }
  }, {
    key: 'initDefaults',
    value: function initDefaults() {
      this.scale = 1;

      this.pos = {
        x: 0,
        y: 0
      };

      this.pinchStart = {
        dist: 0,
        x: 0,
        y: 0
      };

      this.hiResShown = true;
      this.nonCurrentShown = true;
      this.enabled = true;
      this.beforeAnimation = true;
      this.willSwipeItem = false;
      this.isFinalMove = false;
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enabled = false;
      setTimeout(this.enable.bind(this), 1000); //make sure we're not stuck on disabled mode
    }
  }, {
    key: 'enable',
    value: function enable() {
      this.enabled = true;
    }
  }, {
    key: 'update',
    value: function update() {
      this.initElements();
      this.beforeAnimation = true;
    }
    //--------------------| ACTIONS |--------------------//

  }, {
    key: 'disableScroll',
    value: function disableScroll() {
      if (this.scrollDisabled) {
        this.wrap && this.wrap.addClass('pro-fullscreen-unscrollable');
        this.scrollDisabled = false;
      }
    }
  }, {
    key: 'enableScroll',
    value: function enableScroll() {
      if (!this.scrollDisabled) {
        this.wrap && this.wrap.removeClass('pro-fullscreen-unscrollable');
        this.scrollDisabled = true;
      }
    }
  }, {
    key: 'turnTransitionOff',
    value: function turnTransitionOff() {
      if (this.transitionOn) {
        this.wrap && this.wrap.addClass('pro-fullscreen-touching');
        this.transitionOn = false;
      }
    }
  }, {
    key: 'turnTransitionOn',
    value: function turnTransitionOn() {
      if (!this.transitionOn) {
        this.wrap && this.wrap.removeClass('pro-fullscreen-touching');
        this.transitionOn = true;
      }
    }
  }, {
    key: 'hideHiResImages',
    value: function hideHiResImages() {
      if (this.hiResShown) {
        this.wrap && this.wrap.addClass('pro-fullscreen-moving');
        this.hiResShown = false;
      }
    }
  }, {
    key: 'showHiResImages',
    value: function showHiResImages() {
      if (!this.hiResShown) {
        this.wrap && this.wrap.removeClass('pro-fullscreen-moving');
        this.hiResShown = true;
      }
    }
  }, {
    key: 'hideNonCurrentImages',
    value: function hideNonCurrentImages() {
      if (this.nonCurrentShown) {
        this.wrap && this.wrap.addClass('pro-fullscreen-pinching');
        this.nonCurrentShown = false;
      }
    }
  }, {
    key: 'showNonCurrentImages',
    value: function showNonCurrentImages() {
      if (!this.nonCurrentShown) {
        this.wrap && this.wrap.removeClass('pro-fullscreen-pinching');
        this.nonCurrentShown = true;
      }
    }
  }, {
    key: 'setConfiguration',
    value: function setConfiguration(config) {
      this.container = {
        width: config.container.width,
        height: config.container.height
      };
      this.onTap = config.onTap || function () {};
      this.allowSwipe = !!config.allowSwipe;
      this.allowPinch = !!config.allowPinch;
      this.allowScroll = !!config.allowScroll;

      this.mobileSwipeAnimation = config.mobileSwipeAnimation;

      if (!this.allowPinch) {
        this.resetScale();
      }
    }
  }, {
    key: 'move',
    value: function move() {

      if (this.scale === 1) {
        var percentOfScreen = Math.max(0, Math.min(1, 1 - Math.abs(this.pos.x / this.container.width)));
        var isDuringAnimation = percentOfScreen < 1 && percentOfScreen > 0;

        this.wrap.removeClass('pro-fullscreen-before-swipe');

        var _Consts$mobileSwipeAn = _consts2.default.mobileSwipeAnimations,
            EXPAND = _Consts$mobileSwipeAn.EXPAND,
            FADE = _Consts$mobileSwipeAn.FADE,
            CAROUSEL = _Consts$mobileSwipeAn.CAROUSEL,
            CROSSFADE = _Consts$mobileSwipeAn.CROSSFADE;

        switch (this.mobileSwipeAnimation) {
          case EXPAND:
            this.expandAnimation(percentOfScreen);
            break;
          case FADE:
            this.fadeAnimation(percentOfScreen, isDuringAnimation);
            break;
          case CAROUSEL:
            this.carouselAnimation(percentOfScreen, isDuringAnimation);
            break;
          case CROSSFADE:
            //not working yet
            //this.crossfadeAnimation(percentOfScreen, isDuringAnimation);
            break;
        }
      } else {

        var val = 'translate3d(' + this.pos.x + 'px ,' + this.pos.y + 'px ,0) scale(' + this.scale + ')';
        this.wrap.css({
          transform: val,
          '-o-transform': val,
          '-ms-transform': val,
          '-webkit-transform': val
        });
      }
    }
  }, {
    key: 'expandAnimation',
    value: function expandAnimation(percentOfScreen) {
      var scale = Math.round(100 * Math.max(0, (percentOfScreen - 0.5) * 2 - 0.96)) / 100 + 0.96;
      var val = 'translate3d(' + this.pos.x + 'px ,' + this.pos.y + 'px ,0)';

      this.wrap.css({
        transform: val,
        '-o-transform': val,
        '-ms-transform': val,
        '-webkit-transform': val
      });

      this.currentItemContainer.css({
        transform: 'scale(' + scale + ')',
        opacity: 1
      });
      this.nextItemContainer.css({
        transform: 'scale(' + scale + ')',
        opacity: 1
      });
      this.prevItemContainer.css({
        transform: 'scale(' + scale + ')',
        opacity: 1
      });
    }
  }, {
    key: 'fadeAnimation',
    value: function fadeAnimation(percentOfScreen, isDuringAnimation) {
      var val = 'translate3d(' + this.pos.x + 'px ,' + this.pos.y + 'px ,0)';

      if (this.isFinalMove) {
        this.wrap.css({
          transform: val,
          transition: 'transform 400ms ease-in',
          '-o-transform': val,
          '-ms-transform': val,
          '-webkit-transform': val
        });
      } else {
        this.wrap.css({
          transform: val,
          '-o-transform': val,
          '-ms-transform': val,
          '-webkit-transform': val
        });
      }
      if (this.beforeAnimation) {
        this.currentItemContainer.css({
          opacity: 1,
          transition: 'none'
        });
        this.nextItemContainer.css({
          opacity: 0,
          transition: 'none'
        });
        this.prevItemContainer.css({
          opacity: 0,
          transition: 'none'
        });
      } else if (isDuringAnimation) {
        var fastOpacity = Math.max(0, (percentOfScreen - 0.5) * 2);
        var oppositeFastOpacity = Math.max(0, (1 - percentOfScreen - 0.5) * 2);
        this.currentItemContainer.css({
          opacity: fastOpacity
        });
        this.nextItemContainer.css({
          opacity: oppositeFastOpacity
        });
        this.prevItemContainer.css({
          opacity: oppositeFastOpacity
        });
      } else if (this.isFinalMove && this.willSwipeItem) {
        //percentOfScreen = 0
        this.currentItemContainer.css({
          transition: 'opacity 400ms ease-in',
          opacity: 0
        });
        this.nextItemContainer.css({
          transition: 'opacity 400ms ease-in',
          opacity: 1
        });
        this.prevItemContainer.css({
          transition: 'opacity 400ms ease-in',
          opacity: 1
        });
      } else if (this.isFinalMove && !this.willSwipeItem) {
        //percentOfScreen = 1
        this.currentItemContainer.css({
          transition: 'opacity 400ms ease-in',
          opacity: 1
        });
        this.nextItemContainer.css({
          transition: 'opacity 400ms ease-in',
          opacity: 0
        });
        this.prevItemContainer.css({
          transition: 'opacity 400ms ease-in',
          opacity: 0
        });
      }
    }
  }, {
    key: 'carouselAnimation',
    value: function carouselAnimation(percentOfScreen, isDuringAnimation) {
      var right2Left = this.pos.x / this.container.width <= 0;
      var val = 'translateX(' + this.pos.x + 'px)';

      if (this.isFinalMove) {
        this.wrap.css({
          transform: val,
          transition: 'transform 400ms ease-in',
          '-o-transform': val,
          '-ms-transform': val,
          '-webkit-transform': val
        });
      } else {
        this.wrap.css({
          transform: val,
          transition: 'none',
          '-o-transform': val,
          '-ms-transform': val,
          '-webkit-transform': val
        });
      }
      if (this.beforeAnimation) {
        this.currentItemContainer.css({
          zIndex: 9999,
          transform: 'scale(1)',
          transition: 'none',
          opacity: 1
        });
        this.currentItemContent.css({
          filter: 'none'
        });

        this.nextItemContainer.css({
          zIndex: 0,
          transform: 'scale(' + (1 - percentOfScreen / 10) + ')',
          transition: 'none',
          opacity: 1
        });
        this.nextItemContent.css({
          filter: 'none'
        });

        this.prevItemContainer.css({
          zIndex: 0,
          transform: 'scale(' + (1 - percentOfScreen / 10) + ')',
          transition: 'none',
          opacity: 1
        });
        this.prevItemContent.css({
          filter: 'none'
        });
      } else if (isDuringAnimation) {
        this.currentItemContainer.css({
          transform: 'scale(' + (1 - (1 - percentOfScreen) / 10) + ') translateX(' + (right2Left ? Math.max(0, (0.5 - percentOfScreen) * 50) : Math.min(0, (0.5 - percentOfScreen) * -50)) + 'px)',
          zIndex: '' + (percentOfScreen > 0.5 ? 9999 : 0)
        });
        this.currentItemContent.css({
          filter: 'blur(' + (1 - percentOfScreen) * 2 + 'px) brightness(' + (0.75 + percentOfScreen * 0.25) + ')'
        });

        this.nextItemContainer.css({
          transform: 'scale(' + (1 - percentOfScreen / 10) + ') translateX(' + Math.min(0, (0.5 - percentOfScreen) * 50) + 'px)',
          zIndex: '' + (percentOfScreen > 0.5 ? 0 : 9999)
        });
        this.nextItemContent.css({
          filter: 'blur(' + percentOfScreen * 2 + 'px) brightness(' + (1 - percentOfScreen * 0.25) + ')'
        });

        this.prevItemContainer.css({
          transform: 'scale(' + (1 - percentOfScreen / 10) + ') translateX(' + Math.max(0, (0.5 - percentOfScreen) * -50) + 'px)',
          zIndex: '' + (percentOfScreen > 0.5 ? 0 : 9999)
        });
        this.prevItemContent.css({
          filter: 'blur(' + percentOfScreen * 2 + 'px) brightness(' + (1 - percentOfScreen * 0.25) + ')'
        });
      } else if (this.isFinalMove && this.willSwipeItem) {
        //percentOfScreen = 0
        this.currentItemContainer.css({
          zIndex: 0,
          transition: 'transform 400ms ease-in',
          transform: 'scale(0.9) translateX(' + (right2Left ? 25 : -25) + 'px)'
        });
        this.currentItemContent.css({
          transition: 'filter 400ms ease-in',
          filter: 'blur(2px) brightness(0.75)'
        });

        this.nextItemContainer.css({
          transition: 'transform 400ms ease-in',
          transform: 'scale(1) translateX(0px)',
          zIndex: 9999
        });
        this.nextItemContent.css({
          transition: 'filter 400ms ease-in',
          filter: 'none'
        });

        this.prevItemContainer.css({
          transition: 'transform 400ms ease-in',
          transform: 'scale(1) translateX(0px)',
          zIndex: 9999
        });
        this.prevItemContent.css({
          transition: 'filter 400ms ease-in',
          filter: 'none'
        });
      } else if (this.isFinalMove && !this.willSwipeItem) {
        //percentOfScreen = 1
        this.currentItemContainer.css({
          zIndex: 9999,
          transition: 'transform 400ms ease-in',
          transform: 'scale(1) translateX(0px)'
        });
        this.currentItemContent.css({
          transition: 'filter 400ms ease-in',
          filter: 'none'
        });

        this.nextItemContainer.css({
          transition: 'transform 400ms ease-in',
          transform: 'scale(0.9) translateX(-25px)',
          zIndex: 0
        });
        this.nextItemContent.css({
          transition: 'filter 400ms ease-in',
          filter: 'blur(2px) brightness(0.75)'
        });

        this.prevItemContainer.css({
          transition: 'transform 400ms ease-in',
          transform: 'scale(0.9) translateX(25px)',
          zIndex: 0
        });
        this.prevItemContent.css({
          transition: 'filter 400ms ease-in',
          filter: 'blur(2px) brightness(0.75)'
        });
      }
    }
  }, {
    key: 'crossfadeAnimation',
    value: function crossfadeAnimation(percentOfScreen, isDuringAnimation) {
      var scale = Math.round(100 * Math.max(0, (percentOfScreen - 0.5) * 2 - 0.96)) / 100 + 0.96;
      var val = 'translate3d(' + this.pos.x + 'px ,' + this.pos.y + 'px ,0)';

      this.wrap.css({
        transform: val,
        '-o-transform': val,
        '-ms-transform': val,
        '-webkit-transform': val
      });

      if (isDuringAnimation) {
        var fastOpacity = Math.max(0, (percentOfScreen - 0.5) * 2);
        this.currentItemContainer.css({
          transition: 'none',
          transform: 'scale(' + scale + ') translateX(' + -1 * this.pos.x + 'px)',
          opacity: fastOpacity
        });
        this.nextItemContainer.css({
          transition: 'none',
          transform: 'scale(' + scale + ') translateX(' + Number(this.pos.x) + 'px)',
          opacity: 1 - fastOpacity
        });
        this.prevItemContainer.css({
          transition: 'none',
          transform: 'scale(' + scale + ')',
          opacity: 1 - fastOpacity
        });
      } else {
        this.currentItemContainer.css({
          transform: 'none',
          opacity: 1
        });
        this.nextItemContainer.css({
          transform: 'none',
          opacity: 1
        });
        this.prevItemContainer.css({
          transform: 'none',
          opacity: 1
        });
      }
    }

    //--------------------| UTILS |--------------------//

  }, {
    key: 'isDoubleTap',
    value: function isDoubleTap(tapTime, lastTapTime) {
      return tapTime - lastTapTime < 300;
    }
  }, {
    key: 'isDraggingOutOfBounds',
    value: function isDraggingOutOfBounds(dirction) {
      return this.isLastSlide && dirction < 0 || // if last slide and sliding right
      this.isFirstSlide && dirction > 0; // if first slide and sliding left;
    }
  }, {
    key: 'isTap',
    value: function isTap(startTouchEvent, endTouchEvent) {
      try {
        if (startTouchEvent.touches.length === 1 && endTouchEvent.touches.length === 0 && endTouchEvent.timeStamp - startTouchEvent.timeStamp < 150) {
          var startTouch = startTouchEvent.touches[0];
          var endTouch = endTouchEvent.changedTouches[0];
          var distanceX = Math.abs(startTouch.screenX - endTouch.screenX);
          var distanceY = Math.abs(startTouch.screenY - endTouch.screenY);
          return distanceX < 10 && distanceY < 10;
        }
        return false;
      } catch (e) {
        console.warn('StartTouch event is corrupt', startTouchEvent, endTouchEvent);
        return false;
      }
    }
  }, {
    key: 'isSwipe',
    value: function isSwipe(distance, duration) {
      var velocity = distance / duration;
      // determine if slide attempt triggers next/prev slide
      return distance > 10 && velocity > 0.5 || // quick swipe
      distance > this.container.width / 2; // large distance
    }
  }, {
    key: 'calcBounds',
    value: function calcBounds() {
      //moving scaled image - set boundaries

      var rect = this.currentItem[0].getBoundingClientRect();

      var cur_w = rect.width;
      var cur_h = rect.height;

      var max_x = Math.abs(cur_w - this.container.width) / 2;
      var max_y = Math.abs(cur_h - this.container.height) / 2;

      this.bounds = {
        max_x: max_x,
        max_y: max_y,
        min_x: -1 * max_x,
        min_y: -1 * max_y
      };

      // console.log("calculated bounds", this.bounds);
    }
  }, {
    key: 'calcTouchDirection',
    value: function calcTouchDirection(touches) {
      var delta = void 0;
      if (touches.length === 1) {
        delta = {
          x: Math.abs(touches[0].screenX - this.touchStart.x),
          y: Math.abs(touches[0].screenY - this.touchStart.y)
        };
      } else {
        delta = {
          x: Math.abs((touches[0].screenX + touches[1].screenX) / 2 - this.pinchStart.x),
          y: Math.abs((touches[0].screenY + touches[1].screenY) / 2 - this.pinchStart.y)
        };
      }

      var threshold = 10;
      if (delta.x >= threshold && delta.y < threshold) {
        return 'horizontal';
      } else if (delta.y >= threshold && delta.x < threshold) {
        return 'vertical';
      } else if (delta.y >= threshold && delta.x >= threshold) {
        return delta.x > delta.y ? 'horizontal' : 'vertical';
      } else {
        return '';
      }
    }
    //--------------------| HANDLERS |--------------------//

  }, {
    key: 'onTouchStart',
    value: function onTouchStart(event) {
      // this.stopEvent(event, 'onTouchStart');

      this.willSwipeItem = false;
      this.isFinalMove = false;

      if (this.enabled) {
        this.touchStarted = true;
        this.move();
        this.beforeAnimation = false;
        this.startTouch = $.extend(true, {}, event); //the event object can change on some devices
        var touches = event.touches;

        this.turnTransitionOff();

        this.direction = 0;

        if (touches.length === 2) {
          this.handleStartPinching(event, event.touches);
        } else {
          var touch = event.touches[0];
          if (this.scale > 1) {
            this.handleStartDragging(event, touch);
          } else {
            this.handleStartSwiping(event, touch);
          }
        }
      }

      if (this.wrap[0]) {
        this.wrap[0].removeEventListener('touchmove', this.onTouchMove, this.opts);
        this.wrap[0].removeEventListener('touchend', this.onTouchEnd, this.opts);
        this.wrap[0].addEventListener('touchmove', this.onTouchMove, this.opts);
        this.wrap[0].addEventListener('touchend', this.onTouchEnd, this.opts);
      }

      this.move();

      this.stopEvent(event, 'onTouchStart');
    }
  }, {
    key: 'onTouchMove',
    value: function onTouchMove(event) {
      if (!this.enabled) {
        this.stopEvent(event, 'onTouchMove (disabled)');
        return;
      }

      if (!this.touchStarted) {
        this.onTouchStart(event);
      }

      var touches = event.touches;

      var touchDirection = this.touchDirection;
      if (!touchDirection) {
        touchDirection = this.calcTouchDirection(touches);
      }

      if (touchDirection === 'horizontal' || !this.allowScroll || touches.length > 1) {
        //swipping / pinching

        if (touches.length === 2) {
          if (!this.touchDirection) {
            this.showHiResImages();
            this.hideNonCurrentImages();
          }
          this.handlePinching(event, touches);
        } else if (touches.length === 1) {
          if (this.scale > 1) {
            if (!this.touchDirection) {
              this.showHiResImages();
              this.hideNonCurrentImages();
            }
            this.handleDragging(event, touches);
          } else {
            if (!this.touchDirection) {
              this.hideHiResImages();
              this.showNonCurrentImages();
            }
            var touch = touches[0];
            this.handleSwipeDragging(event, touch);
          }
        }

        if (!this.touchDirection) {
          this.disableScroll();
          this.touchDirection = 'horizontal';
        }

        this.move();
      } else if (touchDirection === 'vertical') {
        //scrolling
        if (!this.touchDirection) {
          this.enableScroll();
          this.showHiResImages();
          this.touchDirection = touchDirection;
          // console.log('Got first touchDirection', this.touchDirection);
        }
        return true;
      } else {
        // undecided yet
        this.stopEvent(event, 'onTouchMove (undecided)');
        // console.log('waiting for touchDirection', this.touchDirection);
        return false;
      }
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd(event) {
      var _this2 = this;

      if (!this.enabled) {
        this.stopEvent(event, 'onTouchEnd (disabled)');
        return;
      }

      this.touchStarted = false;
      this.isFinalMove = true;

      this.turnTransitionOn();
      this.touchDirection = '';

      var endTouchTime = event.timeStamp;
      if (this.isTap(this.startTouch, event)) {
        if (this.isDoubleTap(endTouchTime, this.lastTapTime)) {
          clearTimeout(this.singleTapTimeout);
          this.handleDoubleTap(event);
        } else {
          //handle single tap - wait 300ms for double tap
          this.singleTapTimeout = setTimeout(function () {
            _this2.onTap(event);
          }, 300);
        }
        this.lastTapTime = endTouchTime;
      }

      if (this.scale > 1) {
        this.showHiResImages();
        this.hideNonCurrentImages();

        //bounce back to max scale of x2
        // if (this.scale > 2) {
        //   this.scale = 2; - removed because the just between scale > 2 to scale = 2 was annoying
        // }
      } else {
        this.disable(); //wait for the transition to end before allowing any touches

        //regular release - animate slides
        var currentX = this.pos.x;
        var distance = Math.abs(currentX);
        var duration = endTouchTime - this.startTouch.timeStamp;

        this.willSwipeItem = this.isSwipe(distance, duration) && !this.isDraggingOutOfBounds(currentX);
        if (this.willSwipeItem) {
          // determine direction of swipe
          this.direction = (0, _sign2.default)(currentX);
          //set the new position of the slider
          this.pos.x = this.direction * this.container.width;
        } else {
          this.pos.x = 0;
          this.direction = 0;
        }
        this.pos.y = 0;

        this.move();

        if (currentX - this.pos.x === 0) {
          //if there is not transition going to happen, trigger transitionEnd event manually
          this.onTransitionEnd();
        } else {
          //otherwise - register to event end
          var element = this.wrap[0];
          if (element) {
            element.addEventListener('webkitTransitionEnd', this.onTransitionEnd, this.opts);
            element.addEventListener('msTransitionEnd', this.onTransitionEnd, this.opts);
            element.addEventListener('oTransitionEnd', this.onTransitionEnd, this.opts);
            element.addEventListener('otransitionend', this.onTransitionEnd, this.opts);
            element.addEventListener('transitionend', this.onTransitionEnd, this.opts);
          }
        }
      }

      if (this.wrap[0]) {
        this.wrap[0].removeEventListener('touchmove', this.onTouchMove, this.opts);
        this.wrap[0].removeEventListener('touchend', this.onTouchEnd, this.opts);
      }
    }
  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd() {
      var _this3 = this;

      this.pos = { x: 0, y: 0 };
      this.swipeCallback(-1 * this.direction, null, function () {
        _this3.enable();
      });

      this.showHiResImages();
      this.showNonCurrentImages();
      this.move();

      var element = this.wrap[0];
      if (element) {
        element.removeEventListener('webkitTransitionEnd', this.onTransitionEnd, this.opts);
        element.removeEventListener('msTransitionEnd', this.onTransitionEnd, this.opts);
        element.removeEventListener('oTransitionEnd', this.onTransitionEnd, this.opts);
        element.removeEventListener('otransitionend', this.onTransitionEnd, this.opts);
        element.removeEventListener('transitionend', this.onTransitionEnd, this.opts);
      }
    }
  }, {
    key: 'handleStartSwiping',
    value: function handleStartSwiping(event, touch) {
      //on movement start - the slider is at 0
      this.pos = {
        x: 0,
        y: 0
      };

      // get initial touch coords
      this.touchStart = {
        x: touch.screenX,
        y: touch.screenY
      };
    }
  }, {
    key: 'handleStartDragging',
    value: function handleStartDragging(event, touch) {
      this.showHiResImages();
      this.hideNonCurrentImages();

      this.calcBounds();

      this.pinchStart = {
        dist: 0,
        x: touch.screenX,
        y: touch.screenY
      };

      // get initial touch coords
      this.touchStart = {
        x: touch.screenX - this.pos.x,
        y: touch.screenY - this.pos.y
      };
    }
  }, {
    key: 'handleStartPinching',
    value: function handleStartPinching(event, touches) {
      this.showHiResImages();
      this.hideNonCurrentImages();

      this.calcBounds();

      var rect = this.currentItem[0].getBoundingClientRect();

      var touch1clientX = touches[0].clientX;
      var touch1clientY = touches[0].clientY;
      var touch2clientX = touches[1].clientX;
      var touch2clientY = touches[1].clientY;

      var touchesX = (touch1clientX + touch2clientX) / 2;
      var touchesY = (touch1clientY + touch2clientY) / 2;

      var imageOffsetX = rect.left;
      var imageOffsetY = rect.top;
      var imageWidth = rect.width;
      var imageHeight = rect.height;

      //relative touch position in the image
      var touchX = ((touchesX - imageOffsetX) / imageWidth - 0.5) * imageWidth / this.scale;
      var touchY = ((touchesY - imageOffsetY) / imageHeight - 0.5) * imageHeight / this.scale;

      this.pinchStart = {
        dist: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) + Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.scale,
        x: (touches[0].screenX + touches[1].screenX) / 2 - (this.pos.x || 0),
        y: (touches[0].screenY + touches[1].screenY) / 2 - (this.pos.y || 0),
        touchX: touchX,
        touchY: touchY,
        touchScale: this.scale
      };

      // this.stopEvent(event, 'handleStartPinching');
    }
  }, {
    key: 'handleSwipeDragging',
    value: function handleSwipeDragging(event, touch) {
      this.stopEvent(event, 'handleSwipeDragging');

      if (!this.allowSwipe) {
        return;
      }

      // console.log('Got touch events', touches.screenX, touches.screenY);
      var delta = {
        x: touch.screenX - this.touchStart.x,
        y: touch.screenY - this.touchStart.y
      };

      // console.log('Measured Delta', delta);

      // increase resistance if first or last slide
      if (this.isDraggingOutOfBounds(delta.x)) {
        delta.x /= Math.abs(delta.x) / this.container.width + 1; // determine resistance level
      }

      //set the new slides position
      this.pos = {
        x: delta.x,
        y: this.pos.y //on regular swipe - do not change y position
      };
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging(event, touches) {
      this.stopEvent(event, 'handleDragging');

      if (!this.allowPinch) {
        this.resetScale();
        return;
      }

      var deltaPinch = {
        x: touches[0].screenX - this.touchStart.x,
        y: touches[0].screenY - this.touchStart.y
      };

      var x = deltaPinch.x;
      if (this.bounds.min_x > x && this.bounds.min_x - x < 100) {
        //do not limit the drag - but snap within 100px
        x = this.bounds.min_x;
      }
      if (this.bounds.max_x < x && x - this.bounds.max_x < 100) {
        x = this.bounds.max_x;
      }

      var y = deltaPinch.y;
      if (this.bounds.min_y > y && this.bounds.min_y - y < 100) {
        //(500 > 10
        y = this.bounds.min_y;
      }
      if (this.bounds.max_y < y && y - this.bounds.max_y < 100) {
        y = this.bounds.max_y;
      }

      this.pos = { x: x, y: y };

      // this.pos = {
      //   x: Math.min(Math.max(this.bounds.min_x, deltaPinch.x), this.bounds.max_x),
      //   y: Math.min(Math.max(this.bounds.min_y, deltaPinch.y), this.bounds.max_y)
      // };
    }
  }, {
    key: 'handlePinching',
    value: function handlePinching(event, touches) {
      if (!this.allowPinch) {
        this.onTap(event);
        this.stopEvent(event, 'handlePinching (pinch not allowed)');
        return;
      }

      var deltaPinch = {
        scale: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) + Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.pinchStart.dist,
        x: (touches[0].screenX + touches[1].screenX) / 2 - this.pinchStart.x,
        y: (touches[0].screenY + touches[1].screenY) / 2 - this.pinchStart.y
      };

      var newScale = Math.max(1, deltaPinch.scale);

      var pinchPositionFix = {
        x: (newScale - this.pinchStart.touchScale) * this.pinchStart.touchX,
        y: (newScale - this.pinchStart.touchScale) * this.pinchStart.touchY
      };

      this.pos = {
        x: deltaPinch.x - pinchPositionFix.x,
        y: deltaPinch.y - pinchPositionFix.y
      };

      this.scale = newScale;

      this.stopEvent(event, 'handlePinching');
    }
  }, {
    key: 'handleDoubleTap',
    value: function handleDoubleTap(event) {
      if (!this.allowPinch) {
        this.onTap(event);
        this.stopEvent(event, 'handleDoubleTap (pinch not allowed)');
        return;
      }

      if (this.scale > 1) {
        this.scale = 1;
        this.showNonCurrentImages();
      } else {
        this.scale = 2;
        this.hideNonCurrentImages();
      }

      this.pos = {
        x: 0,
        y: 0
      };

      this.turnTransitionOn();
      this.showHiResImages();
      this.move();
    }
  }, {
    key: 'resetScale',
    value: function resetScale() {
      this.scale = 1;

      this.pos = {
        x: 0,
        y: 0
      };

      this.showNonCurrentImages();
      this.turnTransitionOn();
      this.showHiResImages();
      this.move();
    }
  }, {
    key: 'stopEvent',
    value: function stopEvent(event, src) {
      // console.log('Canceled default event', src);
      try {
        //event.stopPropagation();
        // event.preventDefault();
      } catch (e) {
        //
      }
    }
  }]);
  return Swipper;
}();

exports.default = Swipper;